import {tokens} from '@pleo-io/telescope'
import {ListboxButton, ListboxPopover, ListboxList, ListboxOption} from '@reach/listbox'
import styled, {css} from 'styled-components'

import chevronUp from '@helios/shared/images/icons/chevron-up.svg'
import {focusStyles} from '@helios/shared/styles/utils'
import {colors, radii} from '@helios/shared/theme'

export const StyledListboxButton = styled(ListboxButton)`
    display: inline-flex;
    text-align: left;
    cursor: pointer;

    user-select: none;
    background: none;
    border: none;
    align-items: center;
    justify-content: space-between;

    [data-reach-listbox-arrow] {
        display: block;
        margin-left: ${tokens.spacing20};
        font-size: 0.5em;
    }

    [data-reach-listbox-popover] {
        display: block;
        min-width: min-content;
        padding: 0.25rem 0;
        background: hsl(0, 0%, 100%);
        border: solid 1px hsla(0, 0%, 0%, 0.25);
        outline: none;
    }

    :focus-within {
        ${focusStyles()};
        border-radius: ${tokens.arc4};
    }
`

interface ArrowProps {
    $isExpanded: boolean
}

export const Arrow = styled.span<ArrowProps>(({$isExpanded}) => {
    const isExpandedStyles = css`
        transform: rotate(0);
    `

    return css`
        display: block;
        transform: rotate(-180deg);

        ${$isExpanded && isExpandedStyles}

        :after {
            content: url(${chevronUp});
        }
    `
})

export const StyledListboxPopover = styled(ListboxPopover)`
    display: block;
    min-width: 320px;
    padding: ${tokens.spacing20};
    margin-top: 20px;
    background: ${colors.background.default};
    border: none;
    border-radius: ${radii.arc8};
    outline: none;

    &,
    :focus-within {
        outline: -webkit-focus-ring-color auto 4px;
        box-shadow: ${tokens.shadowElevateSubtle};
    }

    &[hidden] {
        display: none;
    }
`

export const StyledListboxList = styled(ListboxList)`
    display: grid;
    padding: 0;
    margin: 0;
    list-style: none;
    gap: ${tokens.spacing20};

    :focus {
        outline: none;
        box-shadow: none;
    }
`

export const StyledListboxOption = styled(ListboxOption)`
    display: block;
    padding: 0;
    margin: 0;

    white-space: nowrap;
    cursor: pointer;
    user-select: none;

    &[aria-selected='true'] {
        color: ${colors.text.brand};
        background: none;
    }
`
